<template>
  <Tabs
    v-model="activeTabIndex"
    @update:modelValue="$emit('update:tab', tabs[$event].id)"
    tabVariant="details-nav"
    size="custom"
    :fullWidth="true"
    v-bind="emitAsProps"
    @primaryAction="$emit('primaryAction', $event)"
  >
    <Tab v-for="tab in tabs" :key="tab.id" v-bind="tab" />
  </Tabs>
</template>

<script setup>
import { computed, ref } from "vue";
import { useEmitAsProps } from "radix-vue";
import { Tabs, Tab } from "@/SharedComponents/Tabs";
import { TaskPrimaryAction } from "@/SharedComponents/Tasks";

const emit = defineEmits(["update:tab", "primaryAction"]);
const emitAsProps = useEmitAsProps(emit);

const props = defineProps({
  tab: { type: String, default: null },
  task: { type: Object, required: true },
  canEdit: { type: Boolean, default: false },
  canComplete: { type: Boolean, default: false },
  busy: { type: Boolean, required: false },
});

const tabs = computed(() => [
  {
    id: null,
    icon: "info-circle",
  },
  {
    id: "comments",
    icon: "chat",
  },
  {
    id: "primary",
    disabled: true,
    is: TaskPrimaryAction,
    props: {
      task: props.task,
      canEdit: props.canEdit,
      canComplete: props.canComplete,
      busy: props.busy,
    },
    event: "primaryAction",
  },
  {
    id: "activity",
    icon: "clock-rewind",
  },
  {
    id: "attachments",
    icon: "attachment",
  },
]);

const activeTabIndex = ref(tabs.value.findIndex((tab) => tab.id === props.tab));
</script>
